import React, {useEffect, useState} from "react";

import {DeleteOutlined} from "@ant-design/icons";
import {Button, Col, message, Popconfirm, Row, Tooltip} from "antd";

import {BucketApproveViewer} from "./BucketApproveViewer";
import api from "../../api";
import {DataCard} from "../helpers/cards/Card";
import {MaterialBlock} from "../helpers/cards/MaterialBlock";
import {StandardTable} from "../helpers/TablePanel";

export function BucketOverview({bucket, projectId, scenarioId, refresh, onApprovalStart}) {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);

	const getMaterialsInBucket = () => {
		setLoading(true);
		api.get(`/projects/${projectId}/scenarios/${scenarioId}/approval-buckets/${bucket._id}`)
			.then(response => {
				console.log(response.data);
				setData(response.data.materials.items);
			})
			.finally(() => setLoading(false));
	};

	const onMaterialDelete = _id => {
		api.post(`/projects/${projectId}/approval-buckets/${bucket._id}/materials/delete`, {
			material_identifiers: [_id],
		})
			.then(() => {
				getMaterialsInBucket();
				refresh();
			})
			.catch(error => {
				console.log(error);
			});
	};

	useEffect(() => {
		getMaterialsInBucket();
	}, [bucket]);

	const getColumns = () => [
		{
			key: "material",
			dataIndex: "material",
			title: "Material",
			render: material => <MaterialBlock material={material}>{material}</MaterialBlock>,
		},
		{
			dataIndex: "description",
			title: "Description",
		},
		{
			dataIndex: "max",
			title: `Current Values`,
			render: (max, item) => (
				<div>
					{item.min} / {item.max}
				</div>
			),
		},
		{
			dataIndex: "new_max",
			title: "Proposed Values",
			render: (max, item) => (
				<div>
					{item.new_min} / {item.new_max}
				</div>
			),
		},
		{
			dataIndex: "actions",
			title: "Actions",
			render: (text, record) =>
				(bucket.status === "pending" || bucket.status === "rejected") && (
					<Popconfirm
						title="Are you sure you want to delete material from this bucket?"
						onConfirm={() => onMaterialDelete(record._id)}
						okText="Yes, Delete"
						cancelText="No">
						<Button
							danger
							style={{margin: "0 5px"}}
							icon={
								<Tooltip title={`Delete material`}>
									<DeleteOutlined />
								</Tooltip>
							}
						/>
					</Popconfirm>
				),
		},
	];

	return (
		<DataCard>
			<Row>
				<Col style={{padding: 5}} span={18}>
					<StandardTable data={data} columns={getColumns()} loading={loading} />
				</Col>
				<Col style={{padding: 5}} span={6}>
					<BucketApproveViewer
						bucket={bucket}
						projectId={projectId}
						onApprovalStart={onApprovalStart}
						refresh={refresh}
					/>
				</Col>
			</Row>
		</DataCard>
	);
}
